import App from './columns/appStatus';
import Company from './columns/company';
import Principal from './columns/principalInvite';
import Invite from './columns/invite';

const principalColumns = [Principal, Company, App, Invite];

export default principalColumns;
